import { render } from "./PageTwo.vue?vue&type=template&id=ac9f2c88&scoped=true"
import script from "./PageTwo.vue?vue&type=script&lang=js"
export * from "./PageTwo.vue?vue&type=script&lang=js"

import "./PageTwo.vue?vue&type=style&index=0&id=ac9f2c88&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac9f2c88"]])

export default __exports__